import request from "@/utils/request";

//查询测试分类
export function getApplicationMaterialsByCategory(code) {
    return request({
        url: '/settings/applicationMaterials/getByCategory?categoryCode=' + code,
        method: "get"
    });
}